import { useCallback, useId, useMemo, useState } from "react";
import {
  evaluatePasswordRules,
  isPasswordValid,
  PasswordRuleChecks,
} from "../utils/passwordPolicy";

interface UsePasswordValidationResult {
  checks: PasswordRuleChecks;
  checklistId: string;
  isValid: boolean;
  touched: boolean;
  showError: boolean;
  handleBlur: () => void;
  reset: () => void;
}

export function usePasswordValidation(
  value: string
): UsePasswordValidationResult {
  const [touched, setTouched] = useState(false);
  const checklistId = useId();
  const checks = useMemo(() => evaluatePasswordRules(value), [value]);
  const isValid = useMemo(() => isPasswordValid(checks), [checks]);

  const handleBlur = useCallback(() => setTouched(true), []);
  const reset = useCallback(() => setTouched(false), []);

  return {
    checks,
    checklistId,
    isValid,
    touched,
    showError: touched && !isValid,
    handleBlur,
    reset,
  };
}